import { BaseApiClient } from "./BaseApiClient";
export const REGIONS_ENDPOINTS = {
    ALL: "/Regions"
};
/**
 * RegionsApiClient - client for fetching regions from BFF
 * @exports
 * @class RegionsApiClient
 * @extends BaseApiClient
 */
export class RegionsApiClient extends BaseApiClient {
    /**
     * Get all regions from BFF
     * @throws {RequiredError}
     * @memberof RegionsApiClient
     */
    getRegions() {
        let fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(REGIONS_ENDPOINTS.ALL, fetchOptions);
    }
}
//# sourceMappingURL=RegionsApiClient.js.map